<template>
  <div style="position: relative" class="px-3 py-3">
    <v-row
      class="header-text pt-0"
      style="background-color: white; color: var(--v-secondary-base)"
    >
      <v-col cols="1">
        <Icon
          :name="'crownrewards'"
          :color="$vuetify.theme.themes.light.secondary"
          :title="'crownrewards'"
          :style="{ height: '25px', width: '25px' }"
        ></Icon>
      </v-col>
      <v-col cols="11" class="pl-1">
        <span class="Rewards text-decoration-underline">Redeem Reward</span>
      </v-col>
    </v-row>
    <v-row class="mt-0" style="background-color: white">
      <v-col :cols="offer_type === 'points' ? 6 : 12">
        <div
          class="align-center background-color-seashell d-inline-flex font-size-xxs nav-button-border-radius pl-1 pr-3"
          @click="$router.go(-1)"
        >
          <v-icon class="">mdi-chevron-left</v-icon>
          Back to Previous Page
        </div>
      </v-col>
      <v-col
        v-if="offer_type === 'points'"
        cols="6"
        class="pr-6 pl-0 text-right font-weight-bold"
        style="color: var(--v-secondary-base)"
      >
        <span class="font-weight-regular">Balance:</span>
        {{ total_points_remaining || 0 }} points
      </v-col>
    </v-row>
    <v-row
      class="header-text"
      style="background-color: var(--v-background-base)"
    >
      <v-col cols="12" class="ma-2"> {{ selected.name }}</v-col>
    </v-row>

    <v-row style="background-color: var(--v-background-base)" class="pb-5">
      <v-col
        v-for="(product, index) in selected.products"
        :key="index"
        cols="6"
        class="pa-0"
      >
        <Product :product="product" :size="'xs'" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Product from "@/components/Product/index.vue";
import Icon from "@/components/UI/Icon.vue";

export default {
  name: "RewardProducts",
  components: {
    Product,
    Icon,
  },
  computed: {
    ...mapGetters("store", {
      total_points_remaining: "total_points_remaining",
      getPointsOffer: "getPointsOffer",
      clubs: "clubs",
    }),
    ...mapState({
      total_points: (state) => state.store.info.points?.total_points,
    }),
  },
  created() {
    this.offer_type = (this.$route.query.points_offer && "points") || "clubs";
    let offer_id =
      this.$route.query.points_offer || this.$route.query.club_offer;
    this.offer_type === "points"
      ? this.setPointsProducts(offer_id)
      : this.setclubProducts(offer_id);
  },
  data() {
    return {
      offer_type: null,
      selected: {},
    };
  },
  methods: {
    setPointsProducts(offer_id) {
      let offer = this.getPointsOffer(offer_id);
      this.selected = {
        products: offer.xtra.products.map((p) => {
          return {
            ...p,
            redeemable: offer.points <= (this.total_points || 0),
            loyalty: true,
            redemption_points_offer: offer.points,
            redemption_points_offer_id:
              offer.points <= this.total_points ? offer_id : undefined,
          };
        }),
        name: offer.xtra.name,
        type: this.offer_type,
        points: offer.points,
      };
    },
    setclubProducts(offer_id) {
      let offer = this.clubs.find((c) => c.club_id === parseInt(offer_id));
      this.selected = {
        products: offer.products.map((p) => {
          return {
            ...p,
            redeemable: p.is_redemption,
            loyalty: true,
          };
        }),
        name: offer.name,
        type: this.offer_type,
      };
    },
  },
};
</script>
